// import api from "../utils/api";
import { URI_API } from "../utils/api";
import useHeaders from "../utils/useHeaders";

const getAllCategories = async () => {
  return await fetch(`${URI_API}/category/all_active`, {
    method: "GET",
    headers: useHeaders.getHeaders(),
  }).then((response) => response.json());
};

const createIdea = async (body: any) => {
  return await fetch(`${URI_API}/idea/create`, {
    method: "POST",
    headers: useHeaders.getHeaders(),
    body: JSON.stringify(body),
  }).then((res) => res.json());
};

const getTopIdeas = async () => {
  return await fetch(`${URI_API}/idea/top`, {
    method: "GET",
    headers: useHeaders.getHeaders(),
  }).then((response) => response.json());
};

const getFinishedIdeas = async () => {
  return await fetch(`${URI_API}/idea/all_finished`, {
    method: "GET",
    headers: useHeaders.getHeaders(),
  }).then((response) => response.json());
};

const getUnfinishedIdeas = async () => {
  return await fetch(`${URI_API}/idea/all_unfinished`, {
    method: "GET",
    headers: useHeaders.getHeaders(),
  }).then((response) => response.json());
};

const getAllIdeas = async () => {
  return await fetch(`${URI_API}/idea/all`, {
    method: "GET",
    headers: useHeaders.getHeaders(),
  }).then((response) => response.json());
};

const getIdea = async (ideaId: number) => {
  return await fetch(`${URI_API}/idea/${ideaId}`, {
    method: "GET",
    headers: useHeaders.getHeaders(),
  }).then((res) => res.json());
};

const upVote = async (ideaId: number) => {
  return await fetch(`${URI_API}/idea/vote/${ideaId}`, {
    method: "PUT",
    headers: useHeaders.getHeaders(),
  }).then((res) => res.json());
};

const verifyVote = async (ideaId: number) => {
  return await fetch(`${URI_API}/idea/voted/${ideaId}`, {
    method: "GET",
    headers: useHeaders.getHeaders(),
  }).then((res) => res.json());
};

const deleteVote = async (ideaId: number) => {
  return await fetch(`${URI_API}/idea/delete_vote/${ideaId}`, {
    method: "DELETE",
    headers: useHeaders.getHeaders(),
  }).then((res) => res.json());
};

const getSuccessCases = async () => {
  return await fetch(`${URI_API}/idea/success_cases`, {
    method: "GET",
    headers: useHeaders.getHeaders(),
  }).then((response) => response.json());
};

const getIdeaChanges = async (ideaId: number) => {
  return await fetch(`${URI_API}/idea_change_log/changes/${ideaId}`, {
    method: "GET",
    headers: useHeaders.getHeaders(),
  }).then((response) => response.json());
};

const createIdeaChangeLog = async (ideaId: number, body: any) => {
  return await fetch(`${URI_API}/idea_change_log/create/${ideaId}`, {
    method: "PUT",
    headers: useHeaders.getHeaders(),
    body: JSON.stringify(body)
  }).then((response) => response.json());
}

const markSuccessIdea = async (file: File, ideaId: number) => {
  const formData = new FormData();
  formData.append("file", file);

  return await fetch(`${URI_API}/idea/success_case/${ideaId}`, {
    method: "PUT",
    headers: {
      Authorization: `Bearer ${useHeaders.getToken()}`
    },
    body: formData
  }).then((response) => response.json());
}

const unmarkSuccessIdea = async (ideaId: number) => {
  return await fetch(`${URI_API}/idea/remove_success_case/${ideaId}`, {
    method: "PUT",
    headers: useHeaders.getHeaders(),
  }).then((response) => response.json());
}

const editIdea = async (
  ideaId: number, 
  body: any
) => {
    return await fetch(`${URI_API}/idea/edit/${ideaId}`, {
      method: "PUT",
      headers: useHeaders.getHeaders(),
      body: JSON.stringify(body),
    }).then((res) => res.json());
}

const getIdeasDates = async () => {
  return await fetch(`${URI_API}/idea/dates`, {
    method: "GET",
    headers: useHeaders.getHeaders(),
  }).then((res) => res.json())
}

const getUnitIdeaCount = async () => {
  return await fetch(`${URI_API}/idea/report/count/all`, {
    method: "GET",
    headers: useHeaders.getHeaders(),
  }).then((res) => res.json())
}

const getUnitIdeaCountRange = async (date_start: string, date_end: string) => {
  return await fetch(`${URI_API}/idea/report/count/${date_start}/${date_end}`, {
    method: "GET",
    headers: useHeaders.getHeaders(),
  }).then((res) => res.json())
}

const getUnitIdeaResponseTime = async () => {
  return await fetch(`${URI_API}/idea/report/response`, {
    method: "GET",
    headers: useHeaders.getHeaders(),
  }).then((res) => res.json())
}

const getUnitIdeaResponseTimeRange = async (date_start: string, date_end: string) => {
  return await fetch(`${URI_API}/idea/report/response/${date_start}/${date_end}`, {
    method: "GET",
    headers: useHeaders.getHeaders(),
  }).then((res) => res.json())
}

const getUnitIdeaFollowup = async () => {
  return await fetch(`${URI_API}/idea/report/followup`, {
    method: "GET",
    headers: useHeaders.getHeaders(),
  }).then((res) => res.json())
}

const getUnitIdeaFollowupRange = async (date_start: string, date_end: string) => {
  return await fetch(`${URI_API}/idea/report/followup/${date_start}/${date_end}`, {
    method: "GET",
    headers: useHeaders.getHeaders(),
  }).then((res) => res.json())
}

const getUnitIdeaApproval = async () => {
  return await fetch(`${URI_API}/idea/report/approval`, {
    method: "GET",
    headers: useHeaders.getHeaders(),
  }).then((res) => res.json())
}

const getUnitIdeaApprovalRange = async (date_start: string, date_end: string) => {
  return await fetch(`${URI_API}/idea/report/approval/${date_start}/${date_end}`, {
    method: "GET",
    headers: useHeaders.getHeaders(),
  }).then((res) => res.json())
}

const getAppUsage = async () => {
  return await fetch(`${URI_API}/idea/report/usage`, {
    method: "GET",
    headers: useHeaders.getHeaders(),
  }).then((res) => res.json())
}

export default {
  createIdea,
  getTopIdeas,
  getFinishedIdeas,
  getUnfinishedIdeas,
  getIdea,
  getIdeaChanges,
  createIdeaChangeLog,
  upVote,
  deleteVote,
  verifyVote,
  getSuccessCases,
  getAllCategories,
  getAllIdeas,
  markSuccessIdea,
  unmarkSuccessIdea,
  editIdea,
  getIdeasDates,
  getUnitIdeaCount,
  getUnitIdeaCountRange,
  getUnitIdeaResponseTime,
  getUnitIdeaResponseTimeRange,
  getUnitIdeaFollowup,
  getUnitIdeaFollowupRange,
  getUnitIdeaApproval,
  getUnitIdeaApprovalRange,
  getAppUsage,
};
